import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import {
  MatPaginator, MatTableDataSource,
  MatDialog, MatDialogRef, MAT_DIALOG_DATA
} from '@angular/material';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { DataSource } from '@angular/cdk/collections';
import { FleetService } from '../../../services/fleet/fleet.service';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/compiler/src/core';


@Component({
  selector: 'app-fleetdetails',
  templateUrl: './fleetdetails.component.html',
  styleUrls: ['./fleetdetails.component.scss']
})
export class FleetdetailsComponent implements OnInit {
  lat: number = 18.533989;
  lng: number = 73.825592;
  columnsToDisplay = [
    'make',
    'model',
    'year',
    'type',
    'odometer',
    'volume',
    'weight',
    'carryingType',
    'driver',
    'volume'
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  fleet: any;
  fleetDataArray = new MatTableDataSource;
  vehicleLicenseNumber: string;
  fleetState: string;
  make: string;
  model: string;
  year: string;
  odometer: string;
  type: string;
  volume: string;
  weight: string;
  carryingType: string;
  transporter: string;
  driver: string;
  vehicleRegistrationDate: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.fleet = this.data.data;
  }

  ngOnInit() {
    console.log("fleet details", this.fleet);
    this.vehicleLicenseNumber = this.fleet.vehicleLicenseNumber;
    this.fleetState = (this.fleet.fState).slice(12);
    this.make = this.fleet.vehicleMake;
    this.model = this.fleet.vehicleModel;
    this.year = this.fleet.vehicleYear;
    this.odometer = this.fleet.vehicleOdometerReading;
    this.carryingType = this.fleet.carryingType;
    this.volume = this.fleet.volume;
    this.weight = this.fleet.weight;
    this.type = this.fleet.vehicleType;
    this.vehicleRegistrationDate = this.fleet.vehicleRegistrationDate;
    this.transporter = this.fleet.transporter.transporterName;
    if (this.fleet.preferedDriver)
      this.driver = this.fleet.preferedDriver.firstName + " " + this.fleet.preferedDriver.lastName;
    this.fleetDataArray.data = [this.fleet];
  }

}